import { render, staticRenderFns } from "./table-proposal-eligible-state-ambit.vue?vue&type=template&id=e2919bc0&scoped=true&"
import script from "./table-proposal-eligible-state-ambit.vue?vue&type=script&lang=js&"
export * from "./table-proposal-eligible-state-ambit.vue?vue&type=script&lang=js&"
import style0 from "./table-proposal-eligible-state-ambit.vue?vue&type=style&index=0&id=e2919bc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2919bc0",
  null
  
)

export default component.exports